var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { filtersToQuery, useFilters } from '@web/utility/hooks/useFilters';
import { Navigate } from 'react-router-dom';
export function NavigateTo(_a) {
    var pathname = _a.pathname, _b = _a.newFilters, newFilters = _b === void 0 ? {} : _b, _c = _a.resetScroll, resetScroll = _c === void 0 ? true : _c;
    var filters = useFilters();
    var query = filtersToQuery(__assign(__assign(__assign({}, filters), newFilters), { scrollY: resetScroll ? null : filters.scrollY }));
    if (resetScroll) {
        window.scrollTo(0, 0);
    }
    return _jsx(Navigate, { to: "".concat(pathname, "?").concat(query), replace: false });
}
export default NavigateTo;
